import { render, staticRenderFns } from "./role-list.vue?vue&type=template&id=4dfb2a30&scoped=true&"
import script from "./role-list.vue?vue&type=script&lang=js&"
export * from "./role-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb2a30",
  null
  
)

export default component.exports